"use client";

import { c as _c } from "react/compiler-runtime";
import { LuPencil } from "react-icons/lu";
const OpenComment = t0 => {
  const $ = _c(38);
  const {
    comment,
    setComment,
    productName,
    onBack,
    onNext,
    isSubmitting: t1,
    submitError: t2
  } = t0;
  const isSubmitting = t1 === undefined ? false : t1;
  const submitError = t2 === undefined ? null : t2;
  let t3;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <div className="flex items-center gap-2 sm:gap-3 mb-2"><div className="w-8 h-8 sm:w-10 sm:h-10 rounded-lg bg-primary-primaryBlue/10 flex items-center justify-center flex-shrink-0"><LuPencil className="w-3.5 h-3.5 sm:w-4 sm:h-4 text-primary-primaryBlue" /></div><h2 className="text-base sm:text-xl font-bold text-gray-900 font-poppins">Share Your Perspective</h2></div>;
    $[0] = t3;
  } else {
    t3 = $[0];
  }
  const t4 = productName || "this therapy";
  let t5;
  if ($[1] !== t4) {
    t5 = <p className="text-xs sm:text-sm text-gray-600 font-poppins mb-4 sm:mb-6">Anything else worth saying about <span className="font-semibold">{t4}</span>? Optional.</p>;
    $[1] = t4;
    $[2] = t5;
  } else {
    t5 = $[2];
  }
  let t6;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <span className="font-semibold">Open comment</span>;
    $[3] = t6;
  } else {
    t6 = $[3];
  }
  let t7;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <label className="block text-xs sm:text-sm font-medium text-gray-900 font-poppins mb-2">{t6}{" "}<span className="text-gray-400 font-normal">(Recommended)</span></label>;
    $[4] = t7;
  } else {
    t7 = $[4];
  }
  const t8 = comment || "";
  let t9;
  if ($[5] !== setComment) {
    t9 = e => setComment(e.target.value);
    $[5] = setComment;
    $[6] = t9;
  } else {
    t9 = $[6];
  }
  let t10;
  if ($[7] !== t8 || $[8] !== t9) {
    t10 = <textarea value={t8} onChange={t9} placeholder="Mechanism questions, payer concerns, head-to-head you'd want to see, etc." className="w-full rounded-lg border-2 border-gray-200 focus:border-primary-primaryBlue focus:outline-none transition-colors p-3 sm:p-4 resize-none text-xs sm:text-sm font-poppins" rows={5} />;
    $[7] = t8;
    $[8] = t9;
    $[9] = t10;
  } else {
    t10 = $[9];
  }
  let t11;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = <p className="mt-3 sm:mt-4 text-xs sm:text-sm text-gray-500 font-poppins">You can submit without writing anything. Your prior answers already capture the structured response.</p>;
    $[10] = t11;
  } else {
    t11 = $[10];
  }
  let t12;
  if ($[11] !== t10) {
    t12 = <div className="bg-white rounded-xl border border-gray-200 shadow-sm p-4 sm:p-6">{t7}{t10}{t11}</div>;
    $[11] = t10;
    $[12] = t12;
  } else {
    t12 = $[12];
  }
  let t13;
  if ($[13] !== t12 || $[14] !== t5) {
    t13 = <div className="flex-1 overflow-y-auto hide-scrollbar px-4 sm:px-6 py-3 sm:py-4"><div className="mb-4 sm:mb-6">{t3}{t5}{t12}</div></div>;
    $[13] = t12;
    $[14] = t5;
    $[15] = t13;
  } else {
    t13 = $[15];
  }
  let t14;
  if ($[16] !== submitError) {
    t14 = submitError && <div className="bg-red-50 border border-red-200 rounded-lg px-3 sm:px-4 py-2 sm:py-3 flex items-center gap-2"><svg className="w-4 h-4 sm:w-5 sm:h-5 text-red-500 flex-shrink-0" fill="currentColor" viewBox="0 0 20 20"><path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z" clipRule="evenodd" /></svg><p className="text-xs sm:text-sm text-red-700 font-poppins">{submitError}</p></div>;
    $[16] = submitError;
    $[17] = t14;
  } else {
    t14 = $[17];
  }
  const t15 = `flex-1 border-2 border-gray-300 text-gray-700 text-sm sm:text-base font-semibold font-poppins rounded-lg py-2.5 sm:py-3 transition-colors ${isSubmitting ? "opacity-50 cursor-not-allowed" : "hover:bg-gray-50"}`;
  let t16;
  if ($[18] !== isSubmitting || $[19] !== onBack || $[20] !== t15) {
    t16 = <button onClick={onBack} disabled={isSubmitting} className={t15}>Back</button>;
    $[18] = isSubmitting;
    $[19] = onBack;
    $[20] = t15;
    $[21] = t16;
  } else {
    t16 = $[21];
  }
  const t17 = false || isSubmitting;
  const t18 = `flex-1 text-white rounded-lg text-sm sm:text-base font-semibold font-poppins py-2.5 sm:py-3 transition-all ${true && !isSubmitting ? "bg-gradient-to-r from-blue-500 to-blue-600 hover:from-blue-600 hover:to-blue-700 shadow-md hover:shadow-lg transform hover:scale-[1.02]" : "bg-gray-300 cursor-not-allowed"}`;
  let t19;
  if ($[22] !== isSubmitting) {
    t19 = isSubmitting ? <span className="flex items-center justify-center gap-2"><svg className="animate-spin h-4 w-4 sm:h-5 sm:w-5 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"><circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" /><path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z" /></svg><span className="hidden sm:inline">Submitting...</span><span className="sm:hidden">Submit...</span></span> : "Submit Anonymously";
    $[22] = isSubmitting;
    $[23] = t19;
  } else {
    t19 = $[23];
  }
  let t20;
  if ($[24] !== onNext || $[25] !== t17 || $[26] !== t18 || $[27] !== t19) {
    t20 = <button disabled={t17} onClick={onNext} className={t18}>{t19}</button>;
    $[24] = onNext;
    $[25] = t17;
    $[26] = t18;
    $[27] = t19;
    $[28] = t20;
  } else {
    t20 = $[28];
  }
  let t21;
  if ($[29] !== t16 || $[30] !== t20) {
    t21 = <div className="flex gap-2 sm:gap-3">{t16}{t20}</div>;
    $[29] = t16;
    $[30] = t20;
    $[31] = t21;
  } else {
    t21 = $[31];
  }
  let t22;
  if ($[32] !== t14 || $[33] !== t21) {
    t22 = <div className="px-4 sm:px-6 py-3 sm:py-4 border-t border-gray-200 bg-white flex flex-col gap-2 sm:gap-3 flex-shrink-0">{t14}{t21}</div>;
    $[32] = t14;
    $[33] = t21;
    $[34] = t22;
  } else {
    t22 = $[34];
  }
  let t23;
  if ($[35] !== t13 || $[36] !== t22) {
    t23 = <>{t13}{t22}</>;
    $[35] = t13;
    $[36] = t22;
    $[37] = t23;
  } else {
    t23 = $[37];
  }
  return t23;
};
export default OpenComment;